export class FeatureFlag {
  name: string = '';
  enabled: boolean = false;
}
